package feature

import feature.auth.viewModel.AuthViewModel

class SetupFeature {
    init {
        instance = this
    }

    companion object {
        private var instance: SetupFeature? = null
        fun shared(): SetupFeature {
            if (instance != null) {
                return instance as SetupFeature
            } else {
                return SetupFeature()
            }
        }
    }

    fun initModules() {
        AuthViewModel().checkIfLoggedIn()
    }
}